import { useState } from 'react';
import { Button, Checkbox } from 'react-bootstrap';
import Dropzone, { DropEvent, FileRejection } from 'react-dropzone';

interface IProps {
    onFileUpload: (hasColumnHeaders: boolean, file: File) => void
}

const Upload = (props: IProps) => {
    const [files, setFiles] = useState<File[]>([]);
    const [hasColumnHeaders, setHasColumnHeaders] = useState(true);

    const handleHasColumnHeadersChange = () => {
        setHasColumnHeaders(!hasColumnHeaders);
    }

    const handleFileDropped = (acceptedFiles: File[], fileRejections: FileRejection[], event: DropEvent) => {
        setFiles(acceptedFiles);
    };

    const handleFileUpload = () => {
        props.onFileUpload(hasColumnHeaders, files[0]);
    };

    const handleRemoveFile = () => {
        setFiles([]);
    }

    return (
        <>
            <div style={{ border: '1px solid #ddd', marginBottom: 0 }}>
                <Dropzone
                    accept={'.csv'}
                    onDrop={handleFileDropped}
                    noKeyboard
                >
                    {({ getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject }) => {
                        return (
                            <>
                                <div {...getRootProps({ isDragActive, isDragAccept, isDragReject })}>
                                    <div style={{ width: '100%', height: 50, display: 'flex', alignItems: 'center' }}>
                                        <div style={{ margin: 'auto', textAlign: 'center', cursor: 'pointer' }}>
                                            Click to select the reconciliation file or drag &amp; drop the reconciliation file here...
                                        </div>
                                    </div>
                                    <input {...getInputProps()} />
                                </div>

                                {files.length > 0 && (
                                    <div style={{ padding: 5, width: '100%', borderTop: '1px solid #ddd' }}>
                                        {files.map((file, index) =>
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <div style={{ marginRight: 10 }}>{file.name}</div>
                                                <div style={{ display: 'flex' }}>
                                                    <Button bsStyle='danger' bsSize='xs' onClick={handleRemoveFile}>Remove</Button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </>
                        );
                    }}
                </Dropzone>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <div><Checkbox checked={hasColumnHeaders} onChange={handleHasColumnHeadersChange}>File has column headers</Checkbox></div>

                {files.length > 0 && (
                    <Button bsStyle='primary' bsSize='small' style={{ marginLeft: 20 }} onClick={handleFileUpload}>Upload File for Processing</Button>
                )}
            </div>
        </>
    );
}

export default Upload;